import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { handleGetRequest } from '../../services/GetTemplate';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { handlePostRequest } from '../../services/PostTemplate';
import { useDispatch } from 'react-redux';

function Stores() {
    const [storeData, setStoreData] = useState();
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(5);
    const [loading, setLoading] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const dispatch= useDispatch()

    const roleId = localStorage.getItem('roleId')
    const data = {
        id: roleId === 1 || roleId === '1' ? 0 : roleId
    }

    const getStores = async () => {
        const response = await dispatch(handlePostRequest(data,`/Authentication/GetAllUsers`, true))
        setStoreData(response)
    };

    useEffect(() => {
        getStores()
    }, [])


    const imageTemplate = (rowData) => {
        return <img src={rowData?.images?.[0]?.src} style={{ height: '50px', width: '50px' }} />;
    };

    const header = () => renderHeader();
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };
     const renderHeader = () => {
         return (
             <div className="Global__Header">
                 <h5 className="m-0"></h5>
                 <span className="block mt-2 md:mt-0 p-input-icon-left">
                     <i className="pi pi-search" />
                     <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search..." />
                 </span>
             </div>
         );
    };
    
     const onGlobalFilterChange = (e) => {
         const value = e.target.value;
         let _filters = { ...filters };
         _filters['global'].value = value;
         setFilters(_filters);
         setGlobalFilterValue(value);
     };


    return (
        <>
            <div className="card">
                {loading ? (
                    <div className="flex justify-content-center align-items-center" style={{ height: '300px' }}>
                        <ProgressSpinner />
                    </div>
                ) : (
                    <DataTable
                        value={storeData}
                        paginator
                        rows={rows}
                        first={first}
                        onPage={onPageChange}
                        globalFilterFields={['id', 'name', 'storeName', 'email', 'contactNumber']}
                        filters={filters}
                        filterDisplay="menu"
                        header={header}
                        //   expandedRows={expandedRows}
                        //   onRowToggle={(e) => setExpandedRows(e.data)}
                        //   rowExpansionTemplate={rowExpansionTemplate}
                        dataKey="product.id"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[5, 10, 20]}
                    >
                        {/* <Column expander={allowExpansion} style={{ width: '3rem' }} /> */}
                        <Column field="id" header="User Id" />
                        <Column body={imageTemplate} header="Image" />
                        <Column field="name" header="Name" />
                        <Column field="storeName" header="Store Name" />
                        <Column field="email" header="Email" />
                        <Column field="contactNumber" header="Cell No" />
                    </DataTable>
                )}
            </div>
        </>
    );
}

export default Stores;
